// AlcanceOscuro.jsx
//
// Fuerza el modo oscuro SOLO dentro de este bloque, aunque la app esté en modo
// claro. Lo usan las superficies que son "tarjeta de foto" del estilo E y por
// eso son siempre oscuras: las pantallas de acceso (AuthShell) y el navbar
// cuando está encima de ellas (#1439).
//
// Hace dos cosas, y las dos hacen falta:
//   1. ThemeProvider con el tema dark → `text.primary`, `background.paper`, etc.
//      de MUI resuelven a los valores oscuros.
//   2. Las CSS vars de `tokens.dark` puestas en la raíz del bloque → los
//      variables CSS de los `sx` resuelven a los valores oscuros (applyThemeVars
//      las pone en :root con el modo activo; acá se pisan para este subárbol).
// Un portal (Dialog, Menu, Popover) se monta FUERA del bloque y pierde el punto
// 2: hay que pasarle `container` apuntando a un elemento de adentro.
import React from "react";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import { createAppTheme, THEME_TOKENS } from "../theme";

const temaOscuro = createAppTheme("dark");
export const VARS_OSCURAS = Object.fromEntries(
  Object.entries(THEME_TOKENS.dark).map(([k, v]) => [`--${k}`, v]),
);

const AlcanceOscuro = React.forwardRef(({ children, sx, activo = true, ...rest }, ref) => {
  if (!activo) return <>{children}</>;
  return (
    <ThemeProvider theme={temaOscuro}>
      <Box ref={ref} sx={{ ...VARS_OSCURAS, colorScheme: "dark", ...sx }} {...rest}>
        {children}
      </Box>
    </ThemeProvider>
  );
});

export default AlcanceOscuro;
